module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURQBR2ABS2kdwTABQ1wBS2QBS2QBR2gBQ1wBS2QBS2gBQ1wBS2eEx3asAAAALdFJOU19/ACaicL8Q249AEIYiwAAAAIJJREFUCNctzSEOAjEUhOHJgquiK2u6Q8gmyE0gSAwKR3AcAYfiADgcSI6wpg2kZi7Ha+CpP5+YB/4PXO2G/tgSnZRPkof7TKXtPuF+YChcFIjs5HtBFzLkuXB+VJoVjJl8Br0R5ZebtRrQ5etEyZaj2psaC6NXqr+MDGrQJf4iGvAL8A4oRK2XFi0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image4.png
// module id = HuFt
// module chunks = 1